import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'arm-info-labels',
  templateUrl: './arm-info-labels.component.html',
  styleUrls: ['./arm-info-labels.component.less']
})
export class ArmInfoLabelsComponent implements OnInit {

  constructor() {
  }

  @Input() infoLabelsId: string;
  @Input() itemsFetchFunction: () => void;
  @Input() items: any = [];

  ngOnInit() {
  }
}
